<script>
import { mapState } from 'vuex'

export default {
  name: 'App',

  computed: {
    ...mapState({
      loader: state => state.loader
    })
  }
}
</script>

<template>
  <div id="app">
    <div
      v-if="loader.status"
      v-loading="loader.status"
      v-loading.fullscreen.lock="true"
      :element-loading-text="loader.text"
    />
    <div>
      <router-view />
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/App.vue